import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { Validators, FormControl } from "@angular/forms";
import { CommonFunctionService ,UserPOSData} from "../../../../services/Common/common-function.service";
import { from } from 'rxjs';
import { TenderTipTaxService } from 'src/app/POS/POSServices/Setup/tender-tip-tax.service';
const swal = require('sweetalert');
@Component({
  selector: 'app-tax-fee',
  templateUrl: './tax-fee.component.html',
  styleUrls: ['./tax-fee.component.scss']
})
export class TaxFeeComponent implements OnInit {
  DateTime:any;
  taxfeenameerror:boolean=false;
  isReadytoUpdatetaxfee : boolean = false;
  merchantdata: UserPOSData ;
  isNewTaxFee: boolean = true;
  isUpdateTaxFee: boolean = false;
  rows;
  TaxFeeName = new FormControl("", [Validators.required, Validators.maxLength(50), Validators.minLength(1)]);
  // TaxFeeName = new FormControl("", [Validators.required, Validators.maxLength(50), Validators.minLength(1), Validators.pattern("^(?! )[a-zA-Zs ]*$")]);
   TaxRate =new FormControl("", [ Validators.required, Validators.min(0),Validators.pattern("^(?![a-zA-Z ])+[0-9]+((?![a-zA-Z@#$%^&*,()! ]).[0-9]{1,2})?$")]);
     //TaxRate =new FormControl("", [ Validators.required]);
  IsDefault: boolean = false;
  id= new FormControl("", [Validators.required]);
  date= new FormControl("", [Validators.required]);
  constructor(
    private router: Router,
    private commonfunction: CommonFunctionService,
    private service: TenderTipTaxService,
    private activatedRoute: ActivatedRoute,
  ) { }

  ngOnInit() {
     this.merchantdata = this.commonfunction.getUserPOSData();
    this.gettaxDetails();
  }
  gettaxDetails() {
    let form = { merchantKeyId: "", id: "", PosSubscriptionId:"" };
    this.activatedRoute.params.subscribe(params => {
      console.log(params["id"]);
      console.log(params["merchantKeyId"]);
      form.id = params["id"];
      form.merchantKeyId = params["merchantKeyId"];
      form.PosSubscriptionId  = this.merchantdata.PosSubscriptionId;
      console.log("formdata---" + form);
    });   

    this.service.GetTaxesFeeDetail(form).subscribe(result => {   
      console.log("result.Id---" + result);
      if (result.Id > 0) {
        this.DateTime=result.DateTime;
        this.IsDefault=result.IsDefault;
        this.isUpdateTaxFee = true;
        this.isNewTaxFee = false;
        this.rows = result;
      } else {
        this.isUpdateTaxFee = false;
        this.isNewTaxFee = true;
      }
    });
 
  }

  Default1()
  {
    this.IsDefault=!this.IsDefault;
   
  }
  
  taxfee() {
    let form = {
      PosSubscriptionId: "",
      TaxFeeName: "",
      TaxRate: "",
      IsDefault: false,
     
    };
    form.TaxFeeName = this.TaxFeeName.value;
    form.TaxRate = this.TaxRate.value;
    form.IsDefault = this.IsDefault;
    
    let merchantdata: UserPOSData = this.commonfunction.getUserPOSData();
    form.PosSubscriptionId = merchantdata.PosSubscriptionId;
    // alert(this.requestDate.value);
    // alert(this.dueDate.value);
    this.service.AddTaxesFee(form).subscribe(result => {
      console.log(" result - ", result);
      if (result != null) {
        var length = +localStorage.getItem('orderlength')
        if(length>0)
        {
          localStorage.removeItem('TaxFeelist');
        swal("Added", "Tax fee added successfully", "success"); 
        this.router.navigate(["/pos/taxfee/manage"]);
        }
        else
        {
          this.router.navigate(["/pos/setup"]);
        }
      }
    });
  }

  updatetaxfee()
  {
    let form = {
      Id:"",
      PosSubscriptionId: "",
      TaxFeeName: "",
      TaxRate: "",
      IsDefault: false,
      DateTime:"",
     
    };
    form.TaxFeeName = this.TaxFeeName.value;
    form.TaxRate = this.TaxRate.value;
    form.IsDefault = this.IsDefault;
    form.Id=this.id.value;
    form.DateTime=this.DateTime;
    let merchantdata: UserPOSData = this.commonfunction.getUserPOSData();
    form.PosSubscriptionId = merchantdata.PosSubscriptionId;
    this.service.UpdateTaxesFee(form).subscribe(result => {
      console.log(" result - ", result);
      if (result != null) {
        var length = +localStorage.getItem('orderlength')
        if(length>0)
        {
           localStorage.removeItem('TaxFeelist');
        swal("Updated", "Tax fee Updated successfully", "success"); 
        this.router.navigate(["/pos/taxfee/manage"]);
        }
        else
        {
          this.router.navigate(["/pos/setup"]);
        }
      }
    });
  }



  onChange()
  {
    let form = { 
     PosSubscriptionId: "",
    TaxFeeName: "",
    TaxRate: "",
    IsDefault: false,};
    this.activatedRoute.params.subscribe(params => {
    
      form.TaxFeeName = this.TaxFeeName.value;
      form.PosSubscriptionId  = this.merchantdata.PosSubscriptionId;
 
    });   

    this.service.GetDuplicateTaxFeeName(form).subscribe(result => {   
      // console.log("result.Id---" + result);
      if(result !=null)
      {
         this.taxfeenameerror=true;            
      }
      else{
        this.taxfeenameerror=false;  
      }
    });
 
  }


  taxfeeError() {
    return this.TaxFeeName.hasError("required") ? "Taxfee is required"
      : this.TaxFeeName.hasError("pattern") ? "Taxfee should allow only alphabets" : "";
  }

  taxrateerrors() {
    return this.TaxRate.hasError("required") ? "TaxRate is required"
    : this.TaxRate.hasError("min") ? "Enter valid TaxRate"
    // : "";
      : this.TaxRate.hasError("pattern") ? "TaxRate should allow only numbers" : "";
  }
  onKey()
  {
    this.isReadytoUpdatetaxfee = true;
  }

}
